import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Modal, Spin } from 'antd';
import { FormProvider, useForm } from 'react-hook-form';

import { useCreateSchoolAbilityMutation } from '@/api/endpoints/schools/schoolSubjectionParams/abilities';
import { DataSection, TextAreaField } from '@/shared/components';
import { useApiRequest } from '@/shared/hooks';

import { SKILL_VALIDATION_SCHEMA } from '../../consts';
import type { TFormData } from '../../types';

import styles from './AbilityModals.module.scss';

type TProps = {
  schoolId: number;
  isModalOpen: boolean;
  handleCancel: VoidFunction;
};

export const CreateAbilityModal = ({ schoolId, isModalOpen, handleCancel }: TProps) => {
  const [createAbility, { isLoading: isAbilityCreating }] = useCreateSchoolAbilityMutation();
  const sendApiRequest = useApiRequest();

  const methods = useForm<TFormData>({
    defaultValues: {
      title: '',
      description: '',
    },
    resolver: yupResolver(SKILL_VALIDATION_SCHEMA),
  });

  const { handleSubmit } = methods;

  const handleSaveAbility = handleSubmit(({ title, description }) => {
    sendApiRequest({
      successMessage: 'Навык успешно создан',
      apiRequestCallback: () =>
        createAbility({
          schoolId,
          data: {
            title,
            description,
          },
        }),
      successCallback: handleCancel,
    });
  });

  return (
    <Modal
      width={600}
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      centered
    >
      <Spin spinning={isAbilityCreating}>
        <div className={styles.wrapper}>
          <FormProvider {...methods}>
            <p className={styles.title}>Добавление навыка</p>
            <div className={styles['content-wrapper']}>
              <DataSection
                titleText="Наименование навыка"
                isTitleRequired
              >
                <TextAreaField
                  fieldName="title"
                  placeholder="Наименование навыка"
                />
              </DataSection>
              <DataSection
                titleText="Описание навыка"
                isTitleRequired
              >
                <TextAreaField
                  fieldName="description"
                  placeholder="Описание навыка"
                />
              </DataSection>
            </div>
            <div className={styles['buttons-wrapper']}>
              <Button
                size="large"
                onClick={handleCancel}
                className={styles.button}
                type="dashed"
              >
                Отмена
              </Button>
              <Button
                size="large"
                onClick={handleSaveAbility}
                type="primary"
                className={styles.button}
                disabled={isAbilityCreating}
              >
                Сохранить
              </Button>
            </div>
          </FormProvider>
        </div>
      </Spin>
    </Modal>
  );
};
